import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "@fontsource-variable/manrope";
import "./styles.css";
import "./design.css";
import "./game/game.css";
import "./theme";

// /play/<token> is a shared prototype and needs no account.
const PublicPlay = lazy(() =>
  import("./PublicPlay").then((m) => ({ default: m.PublicPlay })),
);
const shared = location.pathname.match(/^\/play\/([A-Za-z0-9_-]+)\/?$/);
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {shared ? (
      <Suspense>
        <PublicPlay token={shared[1]} />
      </Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
